import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from '../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class ApiService {

    entity: string;

    constructor(private http: Http) {
    }

    public setEntity(entity: string) {
        this.entity = entity;
    }

    public getAll(): Observable<any> {

        if (this.entity !== null && this.entity !== undefined) {
            return this.http
                .get(API_URL + '/' + this.entity)
                .map(response => response.json())
                .catch(this.handleError);
        } else {
            const error = 'Missing entity';
            return Observable.throw(error);
        }
    }

    public getPage(page, filter = null, method = null): Observable<any> {
        if (this.entity !== null && this.entity !== undefined) {
            // GA-2017-11-23: Quando se usa a paginação da grid, o filter vem a null e preenchido dentro do page
            if (filter == null) {
                filter = page.Filter;
            }
            // GA-2017-11-23 - End
            if (filter !== undefined && filter !== null) {
                let url = API_URL + '/' + this.entity;

                if (method === null) {
                    url += '/GenericSearch';
                } else {
                    url += '/' + method;
                }

                page.Filter = filter;
                page.orderBy = page.sortAsString;

                return this.http
                    .post(url, page)
                    .map(response => {
                        return {
                            data: response.json(),
                            paging: {
                                pageNumber: response.headers.get('x-paging-pagenumber'),
                                pageSize: response.headers.get('x-paging-pagesize'),
                                totalCount: response.headers.get('x-paging-totalcount'),
                                pageCount: response.headers.get('x-paging-pagecount')
                            }
                        };
                    })
                    .catch(this.handleError);

            } else {

                let url = API_URL + '/' + this.entity + '?pageNumber=';
                if (page.pageNumber !== undefined) {
                    url += page.pageNumber;
                } else {
                    url += '1';
                }

                if (page.pageSize !== undefined && page.pageSize !== null) {
                    url += '&pageSize=' + page.pageSize;
                }

                if (page.sortAsString !== undefined) {
                    url += '&orderBy=' + page.sortAsString;
                    url += '&orderByDescending=' + page.orderByDescending;
                }

                return this.http
                    .get(url)
                    .map(response => {
                        return {
                            data: response.json(),
                            paging: {
                                pageNumber: response.headers.get('x-paging-pagenumber'),
                                pageSize: response.headers.get('x-paging-pagesize'),
                                totalCount: response.headers.get('x-paging-totalcount'),
                                pageCount: response.headers.get('x-paging-pagecount')
                            }
                        };
                    })
                    .catch(this.handleError);

            }


        } else {
            const error = 'Missing entity';
            return Observable.throw(error);
        }
    }

    public search(search: string) {
        if (this.entity !== null && this.entity !== undefined) {
            return this.http
                .get(API_URL + '/' + this.entity + '?search=' + search)
                .map(response => response.json())
                .catch(this.handleError);
        } else {
            const error = 'Missing entity';
            return Observable.throw(error);
        }
    }

    public genericSearch(search: any) {
        if (this.entity !== null && this.entity !== undefined) {
            return this.http
                .post(API_URL + '/' + this.entity + '/GenericSearch', { Filter: search })
                .map(response => response.json())
                .catch(this.handleError);
        } else {
            const error = 'Missing entity';
            return Observable.throw(error);
        }
    }

    public save(item: any): Observable<any> {

        if (item.Id !== null && item.Id !== undefined && item.Id !== -1) {
            return this.update(item);
        } else {
            return this.create(item);
        }
    }

    public create(item: any): Observable<any> {
        return this.http
            .post(API_URL + '/' + this.entity, item)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public postRequest(item: any): Observable<any> {
        return this.http
            .post(API_URL + '/' + this.entity, item)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public getById(id: number): Observable<any> {
        return this.http
            .get(API_URL + '/' + this.entity + '/' + id)
            .map(response => response.json())
            .catch(this.handleError);
    }

    public update(item: any): Observable<any> {
        return this.http
            .put(API_URL + '/' + this.entity + '/' + item.Id, item)
            .map(response => true)
            .catch(this.handleError);
    }

    public delete(item: any): Observable<null> {
        return this.http
            .delete(API_URL + '/' + this.entity + '/' + item.Id)
            .map(response => null)
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        console.error('ApiService::handleError', error, this.entity);
        return Observable.throw(error);
    }

    /**
     * Export Excel with filtred entity data
     * @param page
     * @param filter
     * @param method
     */
    public exportExcel(page, filter = null, method = 'ExportToExcel'): Observable<any> {

        if (this.entity !== null && this.entity !== undefined) {

            const url = API_URL + '/' + this.entity + '/' + method;

            page.orderBy = page.sortAsString;
            page.Filter = filter;

            const options = new RequestOptions({
                responseType: ResponseContentType.Blob,
                headers: new Headers({ 'Content-Type': 'application/json' })
            });

            return this.http
                .post(url, page, options)
                .map(response => {

                    let filename = 'Export.xlsx';
                    const disposition = (<Response>response).headers.get('content-disposition')
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(disposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }

                    const blob = (<Response>response).blob();
                    return { blob: blob, filename: filename };
                })
                .catch(this.handleError);

        } else {
            const error = 'Missing entity';
            return Observable.throw(error);
        }
    }

    public getFile(item: any, contentType: string): Observable<any> {
        return Observable.create(observer => {
            const xhr = new XMLHttpRequest();
            let token = localStorage.getItem('auth_token');
            xhr.open('POST', API_URL + '/' + this.entity);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.setRequestHeader('Authorization', `Bearer ${token}`);
            xhr.responseType = 'blob';

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        const blob = new Blob([xhr.response], { type: contentType });
                        observer.next(blob);
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };

            if (item) {
                xhr.send(JSON.stringify(item));
            } else {
                xhr.send();
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/ubi-core/api.service.ts